export default function urlHasFirstSegment(url: string, segment: string) {
  const pathSegments = url.split('/');
  if (pathSegments[1] === segment) {
    return true;
  } else {
    return false;
  }
}
